import api from './api';

// Amir "Ekip İçin Toplu İzin Girişi (Excel)" akışı — assetImportService.js ile aynı desen
// (blob indirme + multipart yükleme). Şablon uç noktası parametre ALMAZ; kapsamdaki
// personel backend'de ön-doldurulmuş gelir.
export const getLeaveImportTemplate = () =>
  api.get('/v1/leave-import/template', { responseType: 'blob' });

export const validateLeaveImport = (file, leaveVariationId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('leaveVariationId', leaveVariationId);
  return api.post('/v1/leave-import/validate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// DİKKAT: execute, istemciden gelen `rows`'u VERİ olarak alır, karar olarak değil —
// sunucu isValid/cost alanlarını yok sayıp doğrulamayı sıfırdan koşar. Çağıran taraf
// sonucu execute'un DÖNDÜĞÜ satırlardan okumalı, gönderdiği satırlardan değil.
export const executeLeaveImport = (leaveVariationId, rows) =>
  api.post('/v1/leave-import/execute', { leaveVariationId, rows });
